'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultExport = new String('.article .image.portrait{max-height:250px;width:auto;}.card{border:1px solid #3a3c40;}.cap-height .card .image.portrait{max-height:300px;width:auto;}.featuredCard.cap-height .card .image.portrait{max-height:300px;width:auto;}@media (min-width:768px){.article .image.portrait{max-height:450px;}}');

_defaultExport.__hash = '3880567684';
_defaultExport.__scoped = '.article.jsx-2620310437 .image.portrait.jsx-2620310437{max-height:250px;width:auto;}.card.jsx-2620310437{border:1px solid #3a3c40;}.cap-height.jsx-2620310437 .card.jsx-2620310437 .image.portrait.jsx-2620310437{max-height:300px;width:auto;}.featuredCard.cap-height.jsx-2620310437 .card.jsx-2620310437 .image.portrait.jsx-2620310437{max-height:300px;width:auto;}@media (min-width:768px){.article.jsx-2620310437 .image.portrait.jsx-2620310437{max-height:450px;}}';
_defaultExport.__scopedHash = '2620310437';
exports.default = _defaultExport;